import { getCsrfToken } from "./constants";

const URL = "/api/keys/";

export type ExternalServiceType = "overpass_api" | "qgis_plugins_proxy";

export interface ExternalServiceKey {
  service_type: ExternalServiceType;
  key: string;
  url: string;
  last_used_at: string | null;
}

interface ExternalServiceKeysResponse {
  status: string;
  keys: ExternalServiceKey[];
}

let keysRequest: Promise<ExternalServiceKey[]> | null = null;

export const getExternalServiceKeys = (): Promise<ExternalServiceKey[]> => {
  if (keysRequest) return keysRequest;

  keysRequest = fetch(URL)
    .then(async (response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = (await response.json()) as ExternalServiceKeysResponse;
      return data.keys;
    })
    .finally(() => {
      keysRequest = null;
    });

  return keysRequest;
};

export const issueExternalServiceKey = async (
  serviceType: ExternalServiceType,
): Promise<void> => {
  const response = await fetch(URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRFToken": getCsrfToken(),
    },
    body: JSON.stringify({ service_type: serviceType }),
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
};
